import { Injectable } from '@angular/core';
import {HttpClient} from '@node_modules/@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ParentUsersService {

  constructor(
    private httpClient: HttpClient,
  ) { }

  // addUserToFamily(parent_id: string, child_id: string) {
  //   return this.httpClient.post('family/add', {parent_id: parent_id, child_id: child_id});
  // }

  addUserToFamily(parent_id: string, schoolId: number, child_id: any[]) {
    return this.httpClient.post('family/add', {school_id: schoolId, parent_id: parent_id, users: child_id});
  }

}
